/**
 * @module category reports
 */
import { createReducer } from '@reduxjs/toolkit';

const defaultState = {};

const categoryReports = createReducer(defaultState, () => {});

export default categoryReports;
